import { createFileRoute } from "@tanstack/react-router";
import { LandingSearchPage } from "@/pages/LandingSearchPage";
import { LandingError, LandingNotFound, landingHead, landingLoader, validateLandingSearch } from "@/lib/landingRoute";

const SLUG = "masini-sub-5000-euro" as const;

export const Route = createFileRoute("/masini-sub-5000-euro/")({
  validateSearch: validateLandingSearch,
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) => landingLoader(SLUG, context.queryClient, deps.search),
  head: ({ loaderData }) => landingHead(SLUG, loaderData),
  errorComponent: LandingError,
  notFoundComponent: LandingNotFound,
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  const data = Route.useLoaderData();
  return <LandingSearchPage slug={SLUG} page={data.page} sortParam={search.sort} />;
}
